import { type FC } from 'react'
import { NavLink } from 'react-router-dom'
import { Placeholder } from 'react-bootstrap'
import classNames from 'classnames'
import { type RangeKey, RANGE_PERIOD } from '../userScoreRange'
import styles from './UserScoreStat.module.scss'

interface UserScoreStatProps {
  userId: string
  score: number | null
  delta: number | null
  isFetching: boolean
  range: RangeKey
}

export const UserScoreStat: FC<UserScoreStatProps> = ({ userId, score, delta, isFetching, range }) => {
  const roundedScore = score === null ? null : Math.round(score)
  const roundedDelta = Math.round(delta ?? 0)

  return (
    <NavLink
      to={`/insights/coaching/${userId}`}
      className='ps-3 gap-1 d-flex flex-column text-reset text-decoration-none h-100'
      aria-label='View meeting score details'
    >
      <div className='lead-small'>Meeting score</div>
      {isFetching ? (
        <Placeholder as='div' animation='glow' className='w-100'>
          <Placeholder xs={8} className='zocks-text-gray-400 rounded-2' />
        </Placeholder>
      ) : roundedScore !== null ? (
        <div className='d-flex align-items-center gap-1'>
          <span className='paragraph-medium bold zocks-text-gray-900'>{roundedScore}</span>
          <span className='paragraph-small'>
            <span className={classNames('bold', roundedDelta >= 0 ? 'zocks-text-success-200' : 'zocks-text-danger-200')}>
              {roundedDelta >= 0 ? `+${roundedDelta}` : `−${Math.abs(roundedDelta)}`}
            </span>{' '}
            <span className='zocks-text-gray-700'>vs previous {RANGE_PERIOD[range]}</span>
          </span>
        </div>
      ) : (
        <div className='paragraph-medium zocks-text-gray-600'>Not enough data</div>
      )}
      <span className={classNames('paragraph-small zocks-text-primary', styles.viewLink, isFetching ? styles.viewLinkHidden : null)} aria-hidden={isFetching}>
        View score details →
      </span>
    </NavLink>
  )
}
